<template>
  <div class="cp-media-modal">
    <div class="layer" />
    <div class="modal-container img">
      <button
        @click="onCloseModalImg"
        type="button"
        class="btn-close"
      >
        <svg class="icon icon-close-modal">
          <use xlink:href="#icon-close-modal"></use>
        </svg>
      </button>
      <div
        ref="slider"
        class="swiper images-slider-wrapper"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in images"
            :key="index"
          >
            <div class="slider-gallery-container-img">
              <img
                :src="item.image.url"
                alt=""
              >
            </div>
          </div>
        </div>
        <div class="medias-modal-slider-navigation">
          <div
            ref="sliderBtnPrev"
            class="btn-prev"
          >
            <svg class="icon icon-medias-slider-arrow"><use xlink:href="#icon-medias-slider-arrow"></use></svg>
          </div>
          <div
            ref="sliderBtnNext"
            class="btn-next"
          >
            <svg class="icon icon-medias-slider-arrow"><use xlink:href="#icon-medias-slider-arrow"></use></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      slider: null,
      sliderOptions: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.btn-next',
          prevEl: '.btn-prev',
        },
      },
    }
  },
  mounted() {
    this.createSlider();
    window.addEventListener('resize', this.slider.updateSize());
  },
  methods: {
    createSlider() {
      this.slider = new Swiper(this.$refs.slider, this.sliderOptions);
    },
    onCloseModalImg() {
      this.$emit('close-modal-img');
    },
  },
}

</script>
